<template>
    <div id="pcm-error-403-view">
        403
    </div>
</template>

<script>
export default {
    name: 'pcm-error-403-view'
}
</script>